import { FC } from 'react';
import { MilieugegevensFlow } from '../milieugegevens-flow';
import { LozingenV2 } from './lozingen-v2';
import { LozingsvormV2 } from './lozingsvorm-v2';
import { MetingenV2 } from './metingen-v2';
import { ZuiveringswijzeV2 } from './zuiveringswijze-v2';

export const GrondteeltMilieugegevensV2: FC = () => (
  <MilieugegevensFlow
    teeltwijze={0}
    renderZuiveringswijze={() => <ZuiveringswijzeV2 teeltwijze={0} />}
    LozingsvormComponent={LozingsvormV2}
    LozingenComponent={LozingenV2}
    MetingenComponent={MetingenV2}
    showFosforStikstof
  />
);
